import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/integration-apps")({
	component: IntegrationAppsLayout,
})

function IntegrationAppsLayout() {
	return <Outlet />
}
